<template>
  <div>
    <el-tabs tab-position="left" style="height: 400px" @tab-click="onChangeTab">
      <el-tab-pane
        v-for="item in depositByOptions"
        :key="item.code"
        :label="item.name"
      >
        <InfoList
          style="padding-top: 0"
          class="das-form-container"
          :columns="2"
        >
          <InfoListLabel>
            <div class="label">Khách hàng</div>
          </InfoListLabel>
          <InfoListInput class="das-form-input">
            <div>
              {{
                booker
                  ? (booker?.first_name ?? '') + ' ' + (booker?.last_name ?? '')
                  : ''
              }}
            </div>
          </InfoListInput>

          <InfoListLabel>
            <div class="label">Thu ngân</div>
          </InfoListLabel>
          <InfoListInput class="das-form-input">
            <div>{{ user?.full_name }}</div>
          </InfoListInput>

          <InfoListLabel>
            <div class="label">Ngày</div>
          </InfoListLabel>
          <InfoListInput class="das-form-input">
            <CalendarSelect
              v-model="formData.date"
              mode="date"
            ></CalendarSelect>
          </InfoListInput>
          <InfoListLabel>
            <div class="label das-label das-label--required">Trang</div>
          </InfoListLabel>
          <InfoListInput
            class="das-form-input"
            style="width: 250px; max-width: 250px"
          >
            <select-with-search-table
              :dropdown-width="400"
              :rows="transactionPageOptions"
              :columns="transactionPageOptionsCol"
              index-field="id"
              :search-fields="['code']"
              :selected-index-field-value="formData.transaction_page"
              :value="formData.transaction_page"
              @selectionChanged="onSelectTransactionPage"
            >
              <template v-slot:value="{ selectedValue: selectedData }">
                {{ selectedData?.code }} {{ selectedData?.desc }}
              </template>
            </select-with-search-table>
          </InfoListInput>

          <InfoListLabel>
            <div class="label das-label das-label--required">Loại</div>
          </InfoListLabel>
          <InfoListInput class="das-form-input">
            <el-select v-model="formData.sub_transaction_id">
              <el-option
                v-for="(
                  option, subTransactionIndex
                ) in filteredSubTransactionOptions"
                :key="`${subTransactionIndex}-${option.c_sub_transaction_id}`"
                :value="option.c_sub_transaction_id"
                :label="`${option?.c_sub_transaction_nm}-${option?.c_sub_transaction_desc}`"
              >
                <span style="float: left">{{
                  option?.c_sub_transaction_desc
                }}</span>
                <span
                  style="
                    margin-left: 24px;
                    float: right;
                    color: var(--el-text-color-secondary);
                    font-size: 13px;
                  "
                  >{{ option?.c_sub_transaction_nm }}</span
                >
              </el-option>
            </el-select>
          </InfoListInput>
          <InfoListLabel v-if="currentTabIndex != 0">
            <div class="label das-label das-label--required">
              Tài khoản nhận
            </div>
          </InfoListLabel>
          <InfoListInput
            v-if="currentTabIndex != 0"
            class="das-form-input"
            style="width: 250px; max-width: 250px"
          >
            <select-with-search-table
              :dropdown-width="400"
              :rows="bankAccountOptions"
              :columns="bankAccountOptionsCol"
              index-field="id"
              :search-fields="['name', 'acc_num', 'code']"
              :selected-index-field-value="formData.bank_account_id"
              :value="formData.bank_account_id"
              @selectionChanged="onSelectAccount"
            >
              <template v-slot:value="{ selectedValue: selectedData }">
                {{ selectedData?.name }} {{ selectedData?.code }}
              </template>
            </select-with-search-table>
          </InfoListInput>

          <InfoListLabel>
            <div class="label das-label das-label--required">
              Số tiền đặt cọc
            </div>
          </InfoListLabel>
          <InfoListInput class="das-form-input">
            <VxCurrencyInput v-model="formData.deposit_money"></VxCurrencyInput>
          </InfoListInput>

          <InfoListLabel>
            <div class="label">Số dư</div>
          </InfoListLabel>
          <InfoListInput class="das-form-input">
            <span
              style="color: rgb(53, 116, 86); font-weight: 700; cursor: pointer"
              >{{ bookingRemainingBalance }}</span
            >
          </InfoListInput>

          <template v-if="currentTabIndex == 2"> </template>

          <InfoListLabel>
            <div class="label">Ghi chú</div>
          </InfoListLabel>
          <InfoListInput class="das-form-input">
            <textarea
              v-model="formData.note"
              rows="5"
              style="width: 100%"
            ></textarea>
          </InfoListInput>
        </InfoList>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { getGroupBalanceApi } from '@/api/booking_service/bookingGroup'
import { getTransPageListApi } from '@/api/common/code'
import { getAllCurrencyApi } from '@/api/common/currency'
import { getListPMSBankAccountApi } from '@/api/configuration/accounting/bankAccount.js'
import { getListApi } from '@/api/configuration/accounting/deposit/hotel'
import { getUserDetailApi } from '@/api/profile/profile'
import InfoList from '@/components/info-list/InfoList.vue'
import InfoListInput from '@/components/info-list/InfoListInput.vue'
import InfoListLabel from '@/components/info-list/InfoListLabel.vue'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
export default {
  components: {
    CalendarSelect,
    InfoList,
    InfoListInput,
    InfoListLabel
  },
  props: {
    // Master booking_room ID
    bookingId: {
      default: null
    },
    // Booking ID
    bookingGroupId: {
      default: null
    },
    booker: {
      default: null
    }
  },
  data() {
    return {
      currentTabIndex: 0,
      user: null,
      bookingBalance: 0,
      formData: {
        id: null,
        date: this.$moment().format('YYYY-MM-DD'),
        note: null,
        bank_name: null,
        /*
          When create new deposit for existing booking
          get booking_id from master booking_room in that booking.
          Left null if send when create new booking
        */
        booking_id: null,
        deposit_by: 1, // = current tab index + 1
        transaction_page: null,
        deposit_money: null,
        sub_transaction_id: null,
        card_num: null,
        expire_date: null,
        bank_account_id: null,
        // This is null by default
        booking_group_id: null
      },
      depositByOptions: [
        {
          name: 'Tiền mặt',
          code: 'CASH_DEPOSIT'
        },
        {
          name: 'Chuyển khoản',
          code: 'TRANSFER_DEPOSIT'
        },
        {
          name: 'Thẻ',
          code: 'CREDIT_DEPOSIT'
        }
      ],
      subTransactionOptions: [],
      subTransactionOptionsCol: [
        {
          headerName: 'Mã',
          field: 'c_transaction_nm'
        },
        {
          headerName: 'Loại',
          field: 'type_nm'
        },
        {
          headerName: 'Loại phụ',
          field: 'method_nm'
        },
        {
          headerName: 'Mô tả',
          field: 'c_sub_transaction_desc'
        }
      ],
      transactionPageOptions: [],
      transactionPageOptionsCol: [
        {
          headerName: 'Tên trang',
          field: 'code'
        },
        {
          headerName: 'Mô tả',
          field: 'desc'
        },
        {
          headerName: 'Mã',
          field: 'p_code'
        }
      ],
      bankAccountOptionsCol: [
        {
          headerName: 'Tài khoản',
          field: 'name'
        },
        {
          headerName: 'Mã',
          field: 'code'
        },
        {
          headerName: 'Số tài khoản',
          field: 'acc_num'
        }
      ],
      bankAccountOptions: [],
      currencyOptions: []
    }
  },
  computed: {
    filteredSubTransactionOptions() {
      return this.subTransactionOptions.filter(
        transaction =>
          transaction.method_nm ===
          this.depositByOptions[this.currentTabIndex].code
      )
    },
    bookingRemainingBalance() {
      const bookingRemainingBalance =
        this.bookingBalance - this.formData.deposit_money
      return bookingRemainingBalance.toLocaleString('en')
    }
  },
  watch: {
    bookingGroupId: function (newValue, oldValue) {
      this.hydrateForm()
    }
  },
  mounted() {
    this.hydrateForm()
  },

  async beforeMount() {
    // await Promise.all([
    //   this.getTransactionPageOption(),
    //   this.getTransactionTypeOptions(),
    //   this.getUserInfo(),
    //   this.getCurrencyOptions(),
    //   this.getBankAccountOptions(),
    //   this.getBookingBalance()
    // ])
  },
  methods: {
    async hydrateForm() {
      this.formData = {
        id: null,
        date: this.$moment().format('YYYY-MM-DD'),
        note: null,
        bank_name: null,
        /*
          When create new deposit for existing booking
          get booking_id from master booking_room in that booking.
          Left null if send when create new booking
        */
        booking_id: null,
        deposit_by: 1, // = current tab index + 1
        transaction_page: null,
        deposit_money: null,
        sub_transaction_id: null,
        card_num: null,
        expire_date: null,
        bank_account_id: null,
        // This is null by default
        booking_group_id: null
      }
      await Promise.all([
        this.getTransactionPageOption(),
        this.getTransactionTypeOptions(),
        this.getUserInfo(),
        this.getCurrencyOptions(),
        this.getBankAccountOptions(),
        this.getBookingBalance()
      ])
      this.formData.booking_id = this.bookingId
    },
    async dehydrateForm() {
      const payload = JSON.parse(JSON.stringify(this.formData))
      payload.date = this.formData.date + 'T00:00:00'
      return payload
    },
    validateFormData() {
      if (this.formData.date == null) {
        return this.$t('validation.required', { field: 'ngày' })
      }
      if (this.formData.deposit_money == null) {
        return this.$t('validation.required', { field: 'số tiền đặt cọc' })
      }
      if (this.formData.sub_transaction_id == null) {
        return this.$t('validation.required', { field: 'loại' })
      }
      if (this.formData.transaction_page == null) {
        return this.$t('validation.required', { field: 'trang' })
      }
      if (
        parseInt(this.currentTabIndex) !== 0 &&
        this.formData.bank_account_id == null
      ) {
        return this.$t('validation.required', { field: 'tài khoản nhận' })
      }
      if (this.currentTabIndex === 2) {
        if (this.formData.card_num == null) {
          return this.$t('validation.required', { field: 'số thẻ' })
        }
        if (this.formData.expire_date == null) {
          return this.$t('validation.required', { field: 'ngày hết hạn' })
        }
      }
      return null
    },
    onSelectTransactionPage(value) {
      this.formData.transaction_page = value.id
    },
    onSelectAccount(value) {
      this.formData.bank_account_id = value.id
    },
    onSelectSubTransactionType(value) {
      this.formData.sub_transaction_id = value?.c_id
    },
    onChangeTab(params) {
      this.currentTabIndex = params.index
      this.formData.sub_transaction_id = null
      this.formData.deposit_by = parseInt(params.index) + 1
      this.$nextTick(() => {
        if (!this.formData.sub_transaction_id) {
          this.formData.sub_transaction_id =
            this.filteredSubTransactionOptions[0].c_sub_transaction_id
        }
      })
    },
    async getTransactionPageOption() {
      await getTransPageListApi().then(res => {
        this.transactionPageOptions = res.data
        if (!this.formData.transaction_page) {
          this.formData.transaction_page = this.transactionPageOptions[0].id
        }
      })
    },
    async getTransactionTypeOptions() {
      await getListApi({ type: 2 }).then(res => {
        this.subTransactionOptions = res.data
        if (!this.formData.sub_transaction_id) {
          this.formData.sub_transaction_id = this.subTransactionOptions.filter(
            transaction =>
              transaction.method_nm ===
              this.depositByOptions[this.currentTabIndex].code
          )[0].c_sub_transaction_id
        }
      })
    },
    async getUserInfo() {
      await getUserDetailApi().then(response => {
        this.user = response.data.user
      })
    },
    async getBankAccountOptions() {
      const data = await getListPMSBankAccountApi({ active: true })
      this.bankAccountOptions = data.data
    },
    async getCurrencyOptions() {
      const data = await getAllCurrencyApi()
      this.currencyOptions = data?.data || []
    },
    async getBookingBalance() {
      if (!this.bookingGroupId) {
        return
      }
      await getGroupBalanceApi(this.bookingGroupId)
        .then(res => {
          this.bookingBalance = res?.data ?? 0
        })
        .catch(err => {
          const message = err?.response?.data?.message
          this.$message({
            type: 'error',
            message: message ?? 'Đã có lỗi xảy ra'
          })
        })
    }
  }
}
</script>
